// extracted by mini-css-extract-plugin
export default {"container":"jP5rSX3vAZQ23r8WkMYX","content":"YHU19MLLh_Nt7gIuYl4A","footerWrapper":"lmyWCbkvGAB9Nv46z1ie"};